import { useEffect, useState } from 'react';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties';
import { toBaseUrl } from '@atlassian/jira-shared-types';
import { useAccountId } from '@atlassian/jira-tenant-context-controller';

const PROPERTY_KEY = 'hasSeenDeploymentFrequencyReport';

export const useHasSeenReport = (): [boolean, () => void] => {
	const baseUrl = toBaseUrl('');
	const accountId = useAccountId();
	const [hasSeen, setHasSeen] = useState(true);

	useEffect(() => {
		const fetchHasSeenDeploymentFrequencyReport = async () => {
			if (accountId == null) return;
			try {
				const res = await getUserProperty<boolean>(baseUrl, accountId, PROPERTY_KEY);
				setHasSeen(res);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (err: any) {
				if (err.statusCode === 404) {
					// if the property does not exist it returns 404
					setHasSeen(false);
				} else {
					throw err;
				}
			}
		};
		fetchHasSeenDeploymentFrequencyReport();
	}, [baseUrl, accountId]);

	return [
		hasSeen,
		() => {
			if (accountId == null) return;
			setHasSeen(true);
			setUserProperties(baseUrl, accountId, PROPERTY_KEY, 'true');
		},
	];
};
